// project-imports
import { getRequest, patchRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - AGENT VERIFICATION ||============================== //

export async function handleAgentVerification(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/agent-verification', action.data);
    case 'read':
      return getRequest(`/agent-verification/${action.id}`);
    case 'list': {
      const params = new URLSearchParams();
      if (action.data?.status) params.set('status', action.data.status);
      if (action.data?.agentId) params.set('agent-id', action.data.agentId);
      if (action.data?.page) params.set('page', String(action.data.page));
      if (action.data?.limit) params.set('limit', String(action.data.limit));
      const qs = params.toString();
      return getRequest(`/agent-verifications${qs ? `?${qs}` : ''}`);
    }
    case 'update':
      return patchRequest(`/agent-verification/${action.id}`, action.data);
    case 'update-status':
      return patchRequest(`/agent-verification/${action.id}/status`, action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleAgentVerification] - Unknown method');
      break;
  }
}
